




















import { Component, Mixins } from "vue-property-decorator";
import { Point } from "../../../../domain/drawing";
import RectangleDragHandles from "../../../dragging/RectangleDragHandles.vue";
import {
  DraggableShapeDrawableObjectMixin
} from "./mixins";
import TexturePattern from "./TexturePattern.vue";
import { IKeyboardEventHandleable } from "..";
import { KeyCodeProcessor } from "./KeyCodeProcessor";

@Component({
  components: {
    TexturePattern,
    RectangleDragHandles,
  },
})
export default class TriangleObject extends Mixins(
  DraggableShapeDrawableObjectMixin
) implements IKeyboardEventHandleable {
  get points(): Point[] {
    return [this.rectangle.bottomLeft, new Point(this.rectangle.center.x, this.rectangle.y), this.rectangle.bottomRight];
  }

  get pointsAsStrings(): string[] {
    return this.toStrings(this.points);
  }

  handleKeyboardEvent(event: KeyboardEvent): boolean {
    if (!this.editingSource.isEditable) {
      return false;
    }
    const moveOffset = KeyCodeProcessor.toMoveOffset(event.keyCode);
    if (moveOffset) {
      this.writeProperty(s => s.geometry.rectangle = s.geometry.rectangle.move(moveOffset));
      return true;
    }
    return false;
  }
}
